import {
    LOAD_FLOOR_LOCATION_METRICS_CALL_BEGIN,
    LOAD_FLOOR_LOCATION_METRICS_CALL_FAILURE,
    LOAD_STOW_ASSOCIATE_METRICS, LOAD_STOW_FLOOR_METRICS,
    LOAD_STOW_PACKAGE_METRICS, LOAD_TOTAL_STOW_PACKAGE_METRICS
} from "../actions/FloorLocationActions";

/**
 * Initial state of the system.
 */
const initialState = {
    loading: false,
    stowPackageMetricsMap: {},
    stowAssociateMetricsMap: {},
    stowFloorMetricsMap: {},
    totalStowPackageMetricsMap: {}
}

/**
 * Reducer function for Floor Location View that changes state
 * based on the action triggered.
 */
export default function floorLocationReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_FLOOR_LOCATION_METRICS_CALL_BEGIN:
            return {
                ...state,
                loading: true
            };
        case LOAD_STOW_PACKAGE_METRICS:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_STOW_FLOOR_METRICS:
            return {
                ...state,
                loading: false,
                stowFloorMetricsMap: action.stowFloorMetricsMap
            };
        case LOAD_STOW_ASSOCIATE_METRICS:
            return {
                ...state,
                loading: false,
                stowAssociateMetricsMap: action.stowAssociateMetricsMap
            };
        case LOAD_TOTAL_STOW_PACKAGE_METRICS:
            return {
                ...state,
                loading: false,
                totalStowPackageMetrics: action.totalStowPackageMetrics
            };
        case LOAD_FLOOR_LOCATION_METRICS_CALL_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/FloorLocationReducer.js